import { combineReducers } from "redux";
import { reducer as formReducer } from 'redux-form'
import { reducer as toastrReducer } from 'react-redux-toastr'

import auth from './auth'
import proposta from './proposta/reducer';
import posPagamentoContrato from './posPagamentoContrato/reducer';
import serviceDesk from './serviceDesk';

export default combineReducers({
    auth,
    toastr: toastrReducer,
    form: formReducer,
    proposta,
    posPagamentoContrato,
    serviceDesk
})
